import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { useIntl } from 'react-intl'
import { messages } from '../messages'
import { JourneyLoadDto } from '../types'

type JourneyViewLoadsTableProps = {
  loads: JourneyLoadDto[]
}

const JourneyViewLoadsTable = ({ loads }: JourneyViewLoadsTableProps) => {
  const { formatMessage } = useIntl()

  if (loads.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {formatMessage(messages.noLoads)}
      </Typography>
    )
  }

  return (
    <Table size="small" sx={{ mb: 3, '& .MuiTableCell-root': { py: 1, px: 1 } }}>
      <TableHead>
        <TableRow sx={{ bgcolor: 'grey.100' }}>
          <TableCell sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
            {formatMessage(messages.trackingNumber)}
          </TableCell>
          <TableCell sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
            {formatMessage(messages.type)}
          </TableCell>
          <TableCell sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
            {formatMessage(messages.quantity)}
          </TableCell>
          <TableCell sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
            {formatMessage(messages.tempControlled)}
          </TableCell>
          <TableCell sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
            {formatMessage(messages.shipFrom)}
          </TableCell>
          <TableCell sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
            {formatMessage(messages.waypoints)}
          </TableCell>
          <TableCell sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
            {formatMessage(messages.deliverTo)}
          </TableCell>
          <TableCell sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
            {formatMessage(messages.customer)}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {loads.map((load) => (
          <TableRow key={load.loadId}>
            <TableCell sx={{ fontSize: '0.8rem' }}>
              {load.trackingNumber || '-'}
            </TableCell>
            <TableCell sx={{ fontSize: '0.8rem' }}>
              {load.loadTypeName || '-'}
            </TableCell>
            <TableCell sx={{ fontSize: '0.8rem' }}>
              {load.quantity}
            </TableCell>
            <TableCell sx={{ fontSize: '0.8rem' }}>
              {load.isTemperatureControlled
                ? load.temperatureSetPoint
                  ? `${load.temperatureSetPoint}°`
                  : formatMessage(messages.yes)
                : '-'}
            </TableCell>
            <TableCell sx={{ fontSize: '0.8rem' }}>
              {load.shipFromLocationName || '-'}
            </TableCell>
            <TableCell sx={{ fontSize: '0.8rem' }}>
              {load.waypointCount}
            </TableCell>
            <TableCell sx={{ fontSize: '0.8rem' }}>
              {load.deliverToLocationName || '-'}
            </TableCell>
            <TableCell sx={{ fontSize: '0.8rem' }}>
              {load.customerName || '-'}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default JourneyViewLoadsTable
